import { Component, OnInit } from '@angular/core'
import { StepperService } from '../../services/stepper-service/stepper.service'
import { PageViewBaseComponent } from '../page-view-base/page-view-base.component'
import { Router } from '@angular/router'
import { LoaderService } from '../../services/loader-service/loader.service';

@Component({
  selector: 'app-page-timeout',
  templateUrl: './page-timeout.component.html',
  styleUrls: ['./page-timeout.component.scss'],
})
export class PageTimeoutComponent extends PageViewBaseComponent implements OnInit {

  constructor(
    router: Router,
    private stepperService: StepperService,
    loaderService: LoaderService,
  ) {
    super(router, loaderService)
  }

  override ngOnInit() {
    super.ngOnInit();
    this.stepperService.setProspectSteps('')
  }
}
